import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceOnboardingSequenceStepTwoWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;

  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 16px;
  }

  transform: translate(20px, -43px);

  @media (max-width: 1300px) {
    transform: translate(calc(-75% + 25px), -45px) scaleX(-1);

    & > div > div:nth-child(2) {
      transform: scaleX(-1);
    }

    & .resource-onboarding-sequence-next {
      transform: scaleX(-1);
      left: 12px;
      right: unset;
    }
  }

  ${BREAKPOINTS.mobile} {
    transform: translate(calc(-75% + 17px), -43px) scaleX(-1);

    & > :not(:last-child) {
      margin-right: 10px;
    }
  }
`;

export const ResourceOnboardingSequenceHeartWrapper = styled.div`
  width: 90px;
  height: 74px;

  border-radius: 1000px;
  border: 2px solid var(--data-skill-background, #ffa366);
  background: rgba(255, 255, 255, 0.01);
  box-shadow: 0px 0px 100px 0px #ffa366;

  ${BREAKPOINTS.mobile} {
    width: 64px;
    height: 64px;
  }
`;

export const ResourceOnboardingSequenceCalloutContainer = styled.div`
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 90%;
    height: 92%;
    transform: translateX(20px);
    border-radius: 24px;
    backdrop-filter: blur(24px);
  }
`;
